import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header, Footer } from '../components/layout';
import { SkipLinks } from '../components/common/SkipLinks';
import { LazyComponent, LazyHeroCarousel, LazyServicesCarousel, LazyContactForm, LazyLocationAccordion } from '../components/common/LazyComponent';
import { Certifications, Statistics, ClientLogos, CompanyVideo, ProjectExpertise, LocationsMap } from '../components/sections';
import { heroSlides } from '../data/heroSlides';
import { services } from '../data/services';
import { certifications } from '../data/certifications';
import { statistics } from '../data/statistics';
import { clientLogos } from '../data/clients';
import { getTouchAccessibilityClasses } from '../lib/responsive-utils';

export function HomePage() {
  const location = useLocation();

  // Handle hash-based scrolling when navigating from other pages
  useEffect(() => {
    if (location.hash) {
      const targetId = location.hash.substring(1);
      // Small delay to ensure DOM is rendered
      const timeout = setTimeout(() => {
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          const headerHeight = 80;
          const targetPosition = targetElement.offsetTop - headerHeight;
          window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        }
      }, 100);
      return () => clearTimeout(timeout);
    }
  }, [location.hash]);

  return (
    <div className={`min-h-screen bg-white ${getTouchAccessibilityClasses()}`}>
      <SkipLinks />
      <Header />
      
      {/* Main content with responsive top padding to account for fixed header */}
      <main id="main-content" className="pt-16 sm:pt-20 lg:pt-24">
        
        {/* Hero Section - Landing/Inicio */}
        <section id="inicio" aria-labelledby="hero-heading" className="relative">
          <h2 id="hero-heading" className="sr-only">Servicios principales de LIEC</h2>
          <LazyComponent fallback={<div className="h-96 bg-gray-200 animate-pulse" />}>
            <LazyHeroCarousel slides={heroSlides} />
          </LazyComponent>
        </section>

          
        {/* Certifications Section */}
        <section aria-labelledby="certifications-heading" className="w-full"  
        style={{
        backgroundImage: 'url(/fondos/01_Fondo.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
      >
          <div className="relative">
            <Certifications certifications={certifications} />
          </div>
        </section>
        
        {/* Company Video Section */}
        <section id="nosotros" aria-labelledby="company-video-heading" className=" lg:py-0 bg-liec-neutral-50">
          <CompanyVideo />
        </section>
        
        {/* Services Section */}
        <section id="servicios" aria-labelledby="services-heading" className="w-full">
          <div className="relative">
            <LazyComponent fallback={<div className="h-64 bg-gray-200 animate-pulse " />}>
              <LazyServicesCarousel services={services} />
            </LazyComponent>
          </div>
        </section>
      
        
        {/* Statistics Section */}
        <section aria-labelledby="statistics-heading" className="w-full">
          <Statistics statistics={statistics} />
        </section>
        
        {/* Project Expertise Section */}
        <section id="proyectos" aria-labelledby="project-expertise-heading" className="py-0">
          <ProjectExpertise />
        </section>
        
        
        {/* Location Section */}
        <section aria-labelledby="locations-heading" className="py-0">
          <LocationsMap />
        </section>
        
        {/* Client Logos Section */}
        <section aria-labelledby="clients-heading" className="py-4 lg:py-4" 
        style={{
        backgroundImage: 'url(/fondos/01_Fondo.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
        >
          <div className="w-full">
            
            <ClientLogos logos={clientLogos} />
          </div>
        </section>
        
        {/* EducaLIEC Section 
        <section id="educaliec" aria-labelledby="educaliec-heading" className="py-16 lg:py-24 bg-liec-secondary-500 text-white">
          <div className="liec-container">
            <div className="text-center">
              <h2 id="educaliec-heading" className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
                EducaLIEC
              </h2>
              <p className="text-lg md:text-xl text-liec-secondary-100 max-w-3xl mx-auto mb-8">
                Programa de capacitación y educación continua en ingeniería y construcción
              </p>
              <div className="max-w-4xl mx-auto">
                <p className="text-base md:text-lg text-liec-secondary-100 mb-6">
                  EducaLIEC es nuestro programa de formación profesional que ofrece cursos especializados, 
                  talleres y certificaciones en las áreas de ingeniería civil, mecánica de suelos, 
                  control de calidad y normatividad en construcción.
                </p>
                <button className="bg-white text-liec-secondary-500 hover:bg-liec-secondary-50 font-semibold py-3 px-8 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-liec-secondary-500">
                  Conoce Nuestros Cursos
                </button>
              </div>
            </div>
          </div>
        </section>
        */}
        {/* Contact Section */}
        <section id="cotiza" aria-labelledby="contact-heading" className="py-8 lg:py-8 "
         style={{
        backgroundImage: 'url(/fondos/02_Fondo_Contacto2.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
        >
          <div className="liec-container">
          
            <LazyComponent fallback={<div className="h-96 bg-gray-200 animate-pulse rounded-lg" />}>
              <LazyContactForm />
            </LazyComponent>
          </div>
        </section>
        
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
}
